export const environment = {
  production: true,
  apiUrl: 'https://api.paseshow.com.ar/',
  socketUrl: '//www.paseshow.com.ar',
  url_host_permissions: 'https://services.paseshow.com.ar/permissions/',
  url_host_ms_user: 'http://ac8811be3b7db47aab584a0ca7d97dba-2142738356.us-west-2.elb.amazonaws.com/',
  url_host_ms_s3: 'https://services.paseshow.com.ar/ms-s3',
  microfront_ps_cms: 'https://paseshow-cms.web.app/',
  microfront_ps_link_ingreo: ' https://paseshow-ingreso.web.app/'
};
